<template>
  <div>
    <a-row :gutter="[8,16]">
      <a-col>
        <div class="simiot-card-box">
          <sale-monthly-performance-info-statistic :id="id" />
        </div>
      </a-col>
    </a-row>

    <a-row :gutter="[8,16]">
      <a-col>
        <div class="simiot-card-box">
          <div v-if="canRecalculate" class="simiot-table-operation-buttons">
            <a-button @click="recalculate">重新计算</a-button>
          </div>
          <a-tabs default-active-key="additional">
            <a-tab-pane key="additional" tab="新增业绩">
              <sale-monthly-performance-info-additional-list :id="id" />
            </a-tab-pane>
            <a-tab-pane key="stored" tab="存量业绩">
              <sale-monthly-performance-info-stored-list :id="id" />
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import SaleMonthlyPerformanceInfoStatistic from '@/views/sale_monthly_performances/info/Statistic'
import SaleMonthlyPerformanceInfoAdditionalList from '@/views/sale_monthly_performances/info/AdditionalList'
import SaleMonthlyPerformanceInfoStoredList from '@/views/sale_monthly_performances/info/StoredList'
import { recalculateSaleMonthlyPerformance } from '@/api/sale_monthly_performance'
import { salePerformanceRecalculateContent } from '@/utils/sale_monthly_performance'
import { hasPermission } from '@/utils/permission'

export default {
  name: 'SaleMonthlyPerformanceShow',
  components: {
    SaleMonthlyPerformanceInfoStoredList,
    SaleMonthlyPerformanceInfoAdditionalList,
    SaleMonthlyPerformanceInfoStatistic
  },
  data() {
    return {
    }
  },
  computed: {
    id() {
      return parseInt(this.$route.params.id)
    },
    canRecalculate() {
      return hasPermission('sale_monthly_performances/recalculate')
    }
  },
  methods: {
    recalculate() {
      this.$confirm({
        title: '重新计算该销售本月业绩？',
        content: salePerformanceRecalculateContent({ useLatestFloorPrice: true }),
        onOk: () => recalculateSaleMonthlyPerformance({
          sale_monthly_performance_id: this.id
        })
      })
    }
  }
}
</script>

